export function parseNumericVar(raw: unknown): number | undefined {
  if (raw === undefined || raw === null || raw === '') return undefined
  const n = Number(raw)
  return Number.isNaN(n) ? undefined : n
}
